<template>
  <div class="chatBox">
    <nav-bar :title="$t('客服')" bg-color="#446D7A" left-arrow left-color="#fff" title-color="#fff" />
    
    <!-- 聊天消息列表 -->
        <div class="chatList" ref="chatList">
          <div v-if="messageList.length === 0" class="emptyMsg">
            {{ $t('暂无聊天记录，有什么问题随时联系我们') }}
          </div>
          <div v-else>
            <!-- 日期分割线 -->
            <div class="dateDivider" v-if="messageList.length > 0">
              <span>{{ formatDate(messageList[0].created_at) }}</span>
            </div>
            
            <!-- 正在输入状态 -->
            <div v-if="typingStatus" class="typingStatus">
              <div class="typingBubble">
                <div class="typingDot"></div>
                <div class="typingDot"></div>
                <div class="typingDot"></div>
              </div>
            </div>
            
            <!-- 消息列表 -->
            <div v-for="(item, index) in messageList" :key="index" class="messageItem">
              <!-- 日期分割线（如果消息跨天） -->
              <div v-if="index > 0 && isDifferentDay(item.created_at, messageList[index-1].created_at)" class="dateDivider">
                <span>{{ formatDate(item.created_at) }}</span>
              </div>
              
              <!-- 用户消息 -->
              <div v-if="!item.status" class="userMsg">
                <div class="userContent">
                  <div class="msgBubble userBubble">
                    <p class="msgText"><span class="senderLabel">我：</span>{{ item.content }}</p>
                    <div v-if="item.images" class="imageGroup">
                      <img v-for="(img, idx) in item.images.split(';')" :key="idx" :src="`${window.origin}${img}`" @click="lookImage({images: item.images})" class="chatImage" />
                    </div>
                  </div>
                  <p class="msgTime">{{ formatDisplayTime(item.created_at) }}</p>
                </div>
              </div>
              
              <!-- 客服回复 -->
              <div v-if="item.status === 1 && item.reply" class="serviceMsg">
                <div class="serviceContent">
                  <div class="msgBubble serviceBubble">
                    <p class="msgText"><span class="senderLabel">客服：</span>{{ item.reply }}</p>
                  </div>
                  <p class="msgTime">{{ item.reply_time ? formatDisplayTime(item.reply_time) : '' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
    
    <!-- 输入区域 -->
    <div class="inputArea">
      <van-field v-model="value" type="textarea" autosize :border="false" :placeholder="$t('请输入留言内容')" />
      <div style="width: 100%;height: 10px;"></div>
      <van-uploader v-model="fileList" :after-read="afterRead" :max-count="6" />
    </div>
    
    <!-- 提交按钮 -->
    <div class="btnBox">
      <p class="btn" @click="submit()">{{ $t('发送') }}</p>
    </div>
  </div>
</template>
<script>
  import { ImagePreview } from 'vant';
  export default {
    data() {
      return {
        value: "",
        fileList: [],
        messageList: [],
        refreshTimer: null,
        lastScrollTop: 0,
        typingStatus: false
      }
    },
    computed: {},
    watch: {
      messageList() {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
    },
    methods: {
      // 获取聊天记录
      getChatHistory() {
        // 保存当前滚动位置
        if (this.$refs.chatList) {
          this.lastScrollTop = this.$refs.chatList.scrollTop;
        }
        
        this.$get({
          url: "/feedback/feedbackList",
          loading: false, // 自动刷新时不显示loading
          success: (res) => {
            // 保存旧的消息长度
            const oldLength = this.messageList.length;
            
            // 从res.data.data获取消息列表（根据API返回的数据结构）
            // 并反转消息顺序，确保最新的消息在底部
            this.messageList = res.data && res.data.data ? [...res.data.data].reverse() : [];
            
            // 如果没有新消息，保持滚动位置
            if (this.$refs.chatList) {
              this.$nextTick(() => {
                // 如果滚动到底部，则保持在底部
                if (oldLength === 0 || this.lastScrollTop >= this.$refs.chatList.scrollHeight - this.$refs.chatList.clientHeight - 50) {
                  this.scrollToBottom();
                } else {
                  // 否则恢复原来的滚动位置
                  this.$refs.chatList.scrollTop = this.lastScrollTop;
                }
              });
            }
          },
          tip: () => {}
        })
      },
      
      // 格式化显示时间
      formatDisplayTime(time) {
        if (!time) return '';
        const date = new Date(time);
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
      },
      
      // 格式化日期（用于分割线）
      formatDate(time) {
        if (!time) return '';
        const date = new Date(time);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        
        // 判断是否是今天
        if (date.toDateString() === today.toDateString()) {
          return this.$t('今天');
        }
        // 判断是否是昨天
        else if (date.toDateString() === yesterday.toDateString()) {
          return this.$t('昨天');
        }
        // 判断是否是今年
        else if (date.getFullYear() === today.getFullYear()) {
          return `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        }
        // 其他情况显示完整日期
        else {
          return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        }
      },
      
      // 判断是否是不同的日期
      isDifferentDay(time1, time2) {
        if (!time1 || !time2) return false;
        const date1 = new Date(time1);
        const date2 = new Date(time2);
        return date1.toDateString() !== date2.toDateString();
      },
      
      // 设置自动刷新
      startAutoRefresh() {
        this.refreshTimer = setInterval(() => {
          this.getChatHistory();
        }, 30000); // 30秒刷新一次
      },
      
      // 清除自动刷新
      clearAutoRefresh() {
        if (this.refreshTimer) {
          clearInterval(this.refreshTimer);
          this.refreshTimer = null;
        }
      },
      
      // 查看图片
      lookImage(data) {
        let imgs = data.images.split(';')
        let images = []
        imgs.forEach(item => {
          images.push(`${window.origin}${item}`)
        })
        ImagePreview(images)
      },
      
      // 上传文件
      afterRead(e) {
        e.status = 'uploading';
        let uploadFile = new FormData()
        uploadFile.append("file", e.file)
        this.$post({
          url: `/upload/local/image`,
          loading: true,
          upload: true,
          data: uploadFile,
          success: (res) => {
            e.status = 'success';
            e.url = `${window.origin}${res.data}`
            e.sendurl = res.data
          },
          tip: () => {
            e.status = 'failed'
          }
        })
      },
      
      // 提交消息
      submit() {
        if (!this.value) return this.$toast(this.$t('请输入留言内容'))
        let image = []
        image = this.fileList.map(item => item.sendurl)
        this.$post({
          url: `/feedback/addFeedback`,
          loading: true,
          data: {
            content: this.value,
            images: image.join(';')
          },
          success: (res) => {
            this.value = ''
            this.fileList = []
            this.$toast(this.$t('发送成功'))
            // 重新获取聊天记录
            this.getChatHistory();
          },
          tip: () => {}
        })
      },
      
      // 滚动到底部
      scrollToBottom() {
        if (this.$refs.chatList) {
          this.$refs.chatList.scrollTop = this.$refs.chatList.scrollHeight;
        }
      }
    },
    created() {
      // 创建时获取聊天记录
      this.getChatHistory();
    },
    mounted() {
      // 挂载后滚动到底部
      this.scrollToBottom();
      // 启动自动刷新
      this.startAutoRefresh();
    },
    beforeDestroy() {
      // 组件销毁时清除定时器
      this.clearAutoRefresh();
    },
    activated() {
      // 组件激活时启动自动刷新
      this.startAutoRefresh();
    },
    deactivated() {
      // 组件停用清除定时器
      this.clearAutoRefresh();
    },
  }
</script>

<style lang="less" scoped>
  .chatBox {
    width: 100%;
    min-height: 100vh;
    background-color: #f0f0f0;
    display: flex;
    flex-direction: column;
    
    /* 聊天消息列表 */
    .chatList {
      flex: 1;
      overflow-y: auto;
      padding: 15px;
      
      /* 日期分割线 */
      .dateDivider {
        text-align: center;
        margin: 15px 0;
        
        span {
          background-color: rgba(255, 255, 255, 0.8);
          color: #999;
          font-size: 12px;
          padding: 5px 10px;
          border-radius: 10px;
        }
      }
      
      /* 正在输入状态 */
      .typingStatus {
        display: flex;
        align-items: flex-start;
        margin-bottom: 10px;
        justify-content: flex-end;
        
        .typingBubble {
          background-color: #9EEA6A;
          border-radius: 18px 18px 18px 4px;
          padding: 8px 12px;
          display: flex;
          align-items: center;
          
          .typingDot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #fff;
            margin: 0 2px;
            animation: typing 1.4s infinite ease-in-out both;
          }
          
          .typingDot:nth-child(1) {
            animation-delay: -0.32s;
          }
          
          .typingDot:nth-child(2) {
            animation-delay: -0.16s;
          }
        }
      }
      
      .emptyMsg {
        text-align: center;
        color: #999;
        padding: 50px 0;
        font-size: 14px;
      }
      
      .messageItem {
        margin-bottom: 15px;
        
        /* 用户消息 */
        .userMsg {
          display: flex;
          align-items: flex-end;
          
          .userContent {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            
            .userBubble {
              background-color: #fff;
              border-radius: 18px 18px 18px 4px;
              box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
            }
          }
        }
        
        /* 客服消息 */
        .serviceMsg {
          display: flex;
          align-items: flex-end;
          justify-content: flex-end;
          
          .serviceContent {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            
            .serviceBubble {
              background-color: #9EEA6A;
              border-radius: 18px 18px 4px 18px;
              box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
            }
          }
        }
        
        /* 消息气泡 */
        .msgBubble {
          max-width: 70%;
          padding: 10px 15px;
          word-break: break-word;
          position: relative;
          
          .msgText {
            font-size: 15px;
            color: #333;
            line-height: 1.4;
          }
          
          .senderLabel {
            font-weight: 500;
            margin-right: 5px;
          }
          
          .serviceBubble .senderLabel {
            color: #075e54;
          }
          
          .imageGroup {
            margin-top: 8px;
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            
            .chatImage {
              width: 80px;
              height: 80px;
              border-radius: 8px;
              object-fit: cover;
              box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
            }
          }
        }
        
        .msgTime {
          font-size: 11px;
          color: #999;
          margin-top: 5px;
          text-align: center;
          width: 100%;
        }
      }
    }
    
    /* 输入区域 */
    .inputArea {
      padding: 10px 15px;
      background-color: #f7f7f7;
      border-top: 1px solid #e0e0e0;
      
      ::v-deep .van-field {
        background-color: #fff;
        border-radius: 20px;
        border: 1px solid #e0e0e0;
        padding: 0 15px;
        
        .van-field__control {
          min-height: 40px;
          max-height: 120px;
          padding: 8px 0;
          color: #333;
          font-size: 15px;
        }
      }
      
      /deep/.van-uploader {
        margin-top: 8px;
        
        .van-uploader__upload {
          border-radius: 8px;
          background-color: #fff;
          border: 1px dashed #dcdcdc;
          width: 80px;
          height: 80px;
          
          .van-icon-plus {
            color: #999;
          }
        }
        
        .van-uploader__preview {
          border-radius: 8px;
          width: 80px;
          height: 80px;
          
          img {
            border-radius: 8px;
          }
        }
      }
    }
    
    /* 提交按钮 */
    .btnBox {
      padding: 0 15px 15px;
      background-color: #f7f7f7;
      
      .btn {
        background-color: #07c160;
        border-radius: 20px;
        padding: 10px 0;
        text-align: center;
        color: #ffffff;
        font-size: 16px;
        font-weight: 500;
        transition: background-color 0.2s;
        
        &:active {
          background-color: #06b055;
        }
      }
    }
  }
  
  /* 输入动画 */
  @keyframes typing {
    0%, 80%, 100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
</style>
